import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";


const Register = () => {
  
  
  const REGISTER_API = config.endpoint + '/auth/register';

  const { enqueueSnackbar } = useSnackbar();

  const [user,setUser] = useState({username:"",password:"",confirmPassword:""})
  const [isLoading,setIsLoading] = useState(false);

  const history = useHistory();

  const handleInputChange = (name,value)=>{

    setUser({...user,[name] : value});

  }

  // const addUserToLocalStorage = () => {

  // }

  
  const redirectToLoginPage = () => {
    history.push("/login");
  }


  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  const register = async (formData) => {

    const postData = {username : formData.username , password : formData.password}

    try{

      setIsLoading(true);
      const res = await axios.post(REGISTER_API,postData);
      console.log(res);
      setIsLoading(false);
      enqueueSnackbar('Registered Successfully',{ 
        variant: 'success',
        });
      redirectToLoginPage();

    }catch(e) {
      console.log(e);
      if (e.response && e.response.status === 400)
      {
      setIsLoading(false);
      return  enqueueSnackbar( e.response.data.message, { variant: 'error'});
      }
      else {
      setIsLoading(false);
      return enqueueSnackbar( "Something went wrong. Check that the backend is running, reachable and returns valid JSON.", { variant: 'error'});
      }
    }



  };

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const validateInput = (data) => {

    let ValidData = {...data}
    if(!ValidData.username){
      enqueueSnackbar("Username is required", {variant: "warning"});
      return false;
    }
    if(ValidData.username.length < 6) {
      enqueueSnackbar("Username must be atleast 6 characters", {variant: "warning"})
      return false;
    }
    if(!ValidData.password) {
      enqueueSnackbar("Password is required", {variant: 'warning'})
      return false;
    }
    if(ValidData.password.length < 6)
    {
      enqueueSnackbar("Password must be at least 6 characters",{ variant: 'warning',})
      return false
    }
    if(ValidData.password!==ValidData.confirmPassword)
    {
      enqueueSnackbar("Passwords do not match",{ variant: 'warning',})
      return false
    }


    register(ValidData);
    return true ;
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons = {false}/>
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            onChange = {(e) => handleInputChange(e.target.name,e.target.value)}
            fullWidth
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            onChange = {(e) => handleInputChange(e.target.name,e.target.value)}
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            onChange = {(e) => handleInputChange(e.target.name,e.target.value)}
            type="password"
            fullWidth
          />
          {/* {isLoading ? <CircularProgress/> : (
            <Button className="button" variant="contained" onClick={() => validateInput(user)}>
            Register Now
           </Button>
          )
          } */}

        {isLoading ? 
          <Box display="flex" flexDirection="row" justifyContent="center"> 
          <CircularProgress className="loading" color="success"/></Box> :
           <Button className="button" variant="contained" onClick={()=>validateInput(user)}>
            Register Now
           </Button>}
           
          <p className="secondary-action">
            Already have an account?{" "}
             <Link className="link" to="/login">
              Login here
             </Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
